import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { SearchIcon } from '../assets';
import { CustomInput } from './styles';
const SearchInput = (props) => {
    const { colors } = useTheme();
    return (_jsx(CustomInput, { ...props, icon: _jsx(SearchIcon, { color: colors.text.secondary }) }));
};
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map